import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const GoldRateContext = createContext(null);

export const GoldRateProvider = ({ children }) => {
  const [goldRate, setGoldRate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGoldRate = async () => {
    try {
      const response = await api.get('/gold-rate');
      setGoldRate(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching gold rate:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch
    fetchGoldRate();

    // Refresh every 5 minutes (300000ms) - gold rates update every 30 mins on backend
    const interval = setInterval(fetchGoldRate, 300000);
    
    return () => clearInterval(interval);
  }, []);

  const value = {
    goldRate,
    loading,
    error,
    refetch: fetchGoldRate,
    // Computed values for convenience
    buyRate: goldRate?.milli_buy_rate || 0,
    sellRate: goldRate?.milli_sell_rate || 0,
    // Use scraped rate_22kt directly instead of calculating from milli rate
    rate22kt: goldRate?.rate_22kt || 0,
    sellRate22kt: goldRate?.gold_sell_rate_per_gram || 0,
  };

  return (
    <GoldRateContext.Provider value={value}>
      {children}
    </GoldRateContext.Provider>
  );
};

export const useGoldRate = () => {
  const context = useContext(GoldRateContext);
  if (!context) {
    throw new Error('useGoldRate must be used within a GoldRateProvider');
  }
  return context;
};

export default GoldRateContext;
